import type { ComponentType, ReactNode } from "react";

export type NavItem = {
	key: string;
	label: string;
	href: string;
	icon: ComponentType<{ className?: string; "aria-hidden"?: boolean }>;
	/** A small count, such as new orders. */
	badge?: number;
};

export type NavLinkProps = {
	href: string;
	className?: string;
	children: ReactNode;
	"aria-current"?: "page";
	"aria-label"?: string;
};

/**
 * The router's link component. Staff web and admin pass a wrapper around
 * TanStack Router's `Link`; the default is a plain anchor.
 */
export type NavLinkComponent = ComponentType<NavLinkProps>;

export const DefaultLink: NavLinkComponent = ({ href, children, ...rest }) => (
	<a href={href} {...rest}>
		{children}
	</a>
);
